import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

const planType = planTypes.ZOOM_REVENUE_ACCELERATOR;

export default {
  key: planTypes[planType],
  data() {
    return {
      planType,
      title: this.$t('billing.planform.title.zoom_revenue_accelerator'),
      logo: getPlanLogo(planTypes.ZOOM_REVENUE_ACCELERATOR),
    };
  },
};
